import { getGardenName, getGardenSlug } from './garden';
import { getGardenOg } from './gardenOg';

/**
 * ページの題名・説明・OGタグを、いま開いている園に合わせて書き換える。
 *
 * 🟥 index.html の <title>・og:title・og:url・canonical が、
 *    全園共通で「きらり保育園箕面」「yourdomain.com」に固定されていた（2026-09-25 発見）。
 *    多賀城で開いても泉中央で開いても、タブにも共有カードにも箕面と出る。
 *    ビルド時の静的HTMLでは園ごとに出し分けられないので、実行時に書き換える。
 * 🟥 og:image は絶対URLでないとSNS側が読めないことが多い。相対パスのままだった。
 */

const ORIGIN = () => window.location.origin;

function setMeta(selector: string, attr: string, value: string) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export function applyGardenMeta(opts?: { titleSuffix?: string; description?: string }) {
  const gardenName = getGardenName();
  const title = opts?.titleSuffix
    ? `${opts.titleSuffix} | ${gardenName}`
    : `タイミーワーカー受け入れマニュアル | ${gardenName}`;
  const description =
    opts?.description ??
    `${gardenName}のタイミーワーカー様向け受け入れマニュアル。初回勤務時の事前確認事項をご案内します。`;
  const url = `${ORIGIN()}${window.location.pathname}`;
  // 🟥 以前はここが全園共通の /images/ogp.jpeg 固定だった。園ごとの外観写真にする
  const image = getGardenOg(getGardenSlug()).image;

  document.title = title;
  setMeta('meta[name="description"]', 'content', description);
  setMeta('link[rel="canonical"]', 'href', url);

  setMeta('meta[property="og:title"]', 'content', title);
  setMeta('meta[property="og:description"]', 'content', description);
  setMeta('meta[property="og:url"]', 'content', url);
  setMeta('meta[property="og:image"]', 'content', image);

  setMeta('meta[name="twitter:title"]', 'content', title);
  setMeta('meta[name="twitter:description"]', 'content', description);
  setMeta('meta[name="twitter:image"]', 'content', image);
}
